import { CartItem, StoreItem } from "services/api/GraphqlTypes";

export function isSoldOut(item: StoreItem | CartItem) {
    const storeItem = item.__typename === "CartItem" ? item.storeItem : item as StoreItem;
    return storeItem.useStock && !storeItem.stock;
}